<template>
  <q-page-container>
    <q-page class="">
      <section class="section-cards-types-services" v-if="allowAttendanceHours">
        <div class="flex row q-pa-md">
          <TypeAttendanceCard
            :list="typeAttendanceList"
            @onClick="openDialogAttendance"
          />
        </div>
      </section>
      <div v-else class="flex row justify-center">
        <label class="label-out-hours q-pt-lg text-center flex">
          Serviço fora do horário de atendimento</label
        >
      </div>
    </q-page>
  </q-page-container>
</template>

<script setup>
import TypeAttendanceCard from "@/components/cards/typeAttendanceCard.vue";
import {
  BAIXA_PRODUTIVA,
  CODIGOS_ESPECIAIS,
  FINISH_ACTIVITY,
  GERAR_OS,
  IMEDIATAR_OS,
  VALIDACAO_LIDER,
} from "@/utils/constants/typeAttendance";
import { date, useQuasar } from "quasar";
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import TypeAttendanceService from "../services/TypeAttendanceService";

let typeAttendanceService = new TypeAttendanceService();
let typeAttendanceList = ref([]);
let allowAttendanceHours = ref(false);
let router = useRouter();
const $q = useQuasar();
const generateImmediateOs = [GERAR_OS, IMEDIATAR_OS];
// IMEDIATAR_OS

const allowedCities = [
  "Brasília",
  "Campinas",
  "Valparaíso de Goiás",
  "Luziânia",
];

const leaderAttendanceType = {
  id_tipoat: VALIDACAO_LIDER,
  descricao: "Validação Líder Refazer/Desob",
  ativo: true,
  route: "active-user",
  is_contingency: false,
};

function getTypeAttendance() {
  if (!allowAttendanceHours.value) return;

  typeAttendanceService.GetTypeAttendances().then((response) => {
    let activeList = response.filter((item) => {
      return item.is_contingency && item.id_tipoat !== 17;
    });
    typeAttendanceList.value.push(...activeList);
  });
}

function showDialogInfo(message, item) {
  return $q
    .dialog({
      message: message,
    })
    .onOk(() => redirectRouterAttendance(item));
}

async function getLocationByIp() {
  return await fetch("https://ipapi.co/json/")
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error(error);
      return null;
    });
}

function showAvaliableCities(item) {
  $q.dialog({
    message:
      "Essa funcionalidade está disponível somente para Brasília, Campinas, Valparaíso de Goiás e Luziânia.",
  }).onOk(() => redirectRouterAttendance(item));
}

async function canUserAcessFinishActivity(item) {
  showAvaliableCities(item);
}

async function openDialogAttendance(item) {
  let messagesMapper = {
    [BAIXA_PRODUTIVA]: `A funcionalidade ${item.descricao} está liberada apenas para baixa de contratos sem movimentação de terminal`,
    [VALIDACAO_LIDER]: `Essa funcionalidade está disponivel somente para os lideres.`,
  };

  // if (item.id_tipoat === FINISH_ACTIVITY) {
  //   return canUserAcessFinishActivity(item);
  // }

  if (messagesMapper[item.id_tipoat]) {
    showDialogInfo(messagesMapper[item.id_tipoat], item);
    return;
  } else {
    redirectRouterAttendance(item);
  }
}

function redirectRouterAttendance(item) {
  const isGenerateOs = generateImmediateOs.includes(item.id_tipoat);

  const routeAction = isGenerateOs
    ? { name: "generate-os", query: { type_attendance: item.id_tipoat } }
    : { name: item.route, params: { type_attendance: item.id_tipoat } };

    if (item.id_tipoat === CODIGOS_ESPECIAIS) {
      router.push({ name: "special-codes" });
    } else if (item.id_tipoat === FINISH_ACTIVITY) {
      router.push({ name: "finish-activity" });
    } else if (item.route === "generate-ocurrence") {
      router.push({ name: "generate-ocurrence", query: { type_attendance: item.id_tipoat } });
     } else {
      router.push(routeAction);
    }
}

function verifyAllowAttendanceHours() {
  const timeStamp = Date.now();
  const formattedString = date.formatDate(timeStamp, "HH");
  if (formattedString >= "07" && formattedString <= "23") {
    allowAttendanceHours.value = true;
  }
}

onMounted(() => {
  verifyAllowAttendanceHours();
  getTypeAttendance();
});
</script>

<style scoped lang="scss">
a {
  text-decoration: none;
}

.label-out-hours {
  color: #ff0000;
  font-weight: bold;
  font-size: 30px;
}
</style>
